import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	contact: {
		marginRight: 8,
		fontSize: 12,
	},
});
